function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import MediaFrame from '../MediaFrame';
import StylableSvg from '../StylableSvg';

var StandardFrame = function StandardFrame(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(MediaFrame, {
    aspectRatio: "1:1",
    className: classNames('psw-l-w-3/4@mobile-s', 'psw-l-w-3/4@mobile-l', 'psw-l-w-1/3@tablet-s', 'psw-l-w-1/3@tablet-l', 'psw-l-w-1/4@laptop', 'psw-l-w-1/4@desktop', 'psw-l-w-1/4@max')
  }, children);
};

StandardFrame.defaultProps = {
  children: null
};
StandardFrame.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element), PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
/**
 * The Error component can be used to display generic/specific error.
 *
 * It is comprised of four main parts
 *
 * - Graphic illustation: Web client can simply pass the `graphicType` to
 * indicate which graphic it want to use. Web client can also pass the graphic
 * prop to use custom illustration. However, it is highly recommend to use
 * graphicType whenever possible.
 *
 * - Header text (mandatory)
 *
 * - Body text (optional)
 *
 * - CTAs (optional as well)
 *
 * !!IMPORTANT!! In order to use this component, Web client must
 * configure the `Image` and `StyleableSvg` components ahead
 * before using this component.Failure in doing so will prevent
 * the graphic illustration to render properly.
 *
 * Collaborating Components
 * - [MediaFrame](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/MediaFrame)
 * - [StylableSvg](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/StylableSvg)
 * - [Link](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Link)
 */

var Error = /*#__PURE__*/function (_PureComponent) {
  _inherits(Error, _PureComponent);

  var _super = _createSuper(Error);

  function Error() {
    var _this;

    _classCallCheck(this, Error);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getIllustrationGraphic", function () {
      var _this$props = _this.props,
          graphic = _this$props.graphic,
          graphicType = _this$props.graphicType;

      switch (graphicType) {
        case 'none':
          return null;

        case 'custom':
          return graphic;

        case 'general':
        /* falls through */

        default:
          return /*#__PURE__*/React.createElement(StandardFrame, null, graphic || /*#__PURE__*/React.createElement(StylableSvg, {
            namespace: "ps-illustration",
            type: "error-general-fail"
          }));
      }
    });

    return _this;
  }

  _createClass(Error, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          qa = _this$props2.qa,
          className = _this$props2.className,
          header = _this$props2.header,
          body = _this$props2.body,
          ctas = _this$props2.ctas;
      return /*#__PURE__*/React.createElement("section", {
        "data-qa": qa,
        className: classNames('psw-l-stack-center', className)
      }, this.getIllustrationGraphic(), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-t-align-c', 'psw-l-w-1/1@mobile-s', 'psw-l-w-1/1@mobile-l', 'psw-l-w-2/3@tablet-s', 'psw-l-w-2/3@tablet-l', 'psw-l-w-1/2@laptop', 'psw-l-w-5/6@desktop', 'psw-l-w-5/6@max')
      }, header && /*#__PURE__*/React.createElement("h1", {
        className: classNames('psw-t-title-s', 'psw-m-t-6'),
        "data-qa": "".concat(qa, "#header")
      }, header), body && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-t-body', 'psw-m-t-5'),
        "data-qa": "".concat(qa, "#body")
      }, body)), ctas && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-6",
        "data-qa": "".concat(qa, "#ctas")
      }, ctas));
    }
  }]);

  return Error;
}(PureComponent);

Error.defaultProps = {
  qa: 'error',
  className: '',
  body: '',
  graphicType: 'general',
  ctas: null,
  graphic: null
};
Error.propTypes = {
  /**
   * The test id to use for QA automation. This value should be unique on any given page.
   */
  qa: PropTypes.string,

  /**
   * Any additional classes to apply to the root of the component. This is useful for adding
   * spacing to the component.
   */
  className: PropTypes.string,

  /**
   * The header text
   */
  header: PropTypes.string.isRequired,

  /**
   * The body text
   */
  body: PropTypes.string,

  /**
   * The graphics type that we use for illustration
   */
  graphicType: PropTypes.oneOf(['general', 'none', 'custom']),

  /**
   * Call-to-action section. This can be container with single link or multiple links
   */
  ctas: PropTypes.element,

  /**
   * A custom graphics for the illustation
   */
  graphic: PropTypes.element
};
export default Error;